import * as angular from 'angular';
import 'angular-ui-router';
import { OnboardingService } from './OnboardingService';
export default angular
    .module('onboarding', ['ui.router'])
    .service('OnboardingService', OnboardingService)
    .name;
